import { LicenseToDriveOutputData } from './license-to-drive-output-data.model';


export class EmployeeDetailsOutput implements IEmployeeDetailsOutput {
    /** The auto-generated id of the employee details master */
    employee_details_id!: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The employee number with 13 character limit */
    employee_number!: string;
    /** The employee rfid  tag with 50 character limit */
    rfid_tag!: string;
    /** The employee first name with 50 character limit */
    first_name!: string;
    /** The employee middle name with 50 character limit */
    middle_name!: string;
    /** The employee last name with 50 character limit */
    last_name!: string;
    /** The auto-generated id of the designation master */
    designation_id!: number;
    /** The street_1 with 255 character limit */
    street_1!: string;
    /** The street_1 with 255 character limit */
    street_2!: string;
    /** The auto-generated id of the designation master */
    city_id!: number;
    /** The zip code with 6 character limit */
    zip_code!: string;
    /** The zip code with 13 character limit */
    contact_number_1!: string;
    /** The zip code with 13 character limit */
    contact_number_2!: string;
    /** The date of birth with 10 character limit */
    date_of_birth!: string;
    /** The date of joining with 10 character limit */
    date_of_joining!: string;
    /** The date 0f leaving with 10 character limit */
    date_of_leaving!: string;
    /** The driving experience of employee */
    driving_experience!: number;
    /** The  0 for NO 1 for Yes */
    license_available!: number;
    /** The next passing date with 10 character limit */
    license_number!: string;
    /** The license issue date with 10 character limit */
    license_issue_date!: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date!: string;
    /** The life insurance number with 50 character limit */
    life_insurance_number!: string;
    /** The life insurance expiry date with 10 character limit */
    life_insurance_expiry_date!: string;
    /** The mediclaim number with 50 character limit */
    mediclaim_number!: string;
    /** The mediclaim expiry date with 10 character limit */
    mediclaim_expiry_date!: string;
    /** The employee photo with 2048 character limit */
    employee_photo!: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** Manage status of employee details. 0 For De-active, 1 For Active */
    status!: number;
    /** The auto-generated creating time of tbl_alert_group item add */
    creating_date!: any;
    /** The auto-generated creating or updating time of tbl_alert_group item add or update */
    updating_date!: any;
    /** The city name with 255 character limit */
    city_name!: string;
    /** The auto-generated id of the state master */
    state_id!: number;
    /** The state name with 255 character limit */
    state_name!: string;
    /** The auto-generated id of the country master */
    country_id!: number;
    /** The country name with 255 character limit */
    country_name!: string;
    /** The branch name with 255 character limit */
    branch!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 13 character limit */
    company_name!: string;
    /** The designation name with 13 character limit */
    designation_name!: string;
    license_to_drive!: LicenseToDriveOutputData[];

    constructor(data?: IEmployeeDetailsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee_details_id = _data["employee_details_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.employee_number = _data["employee_number"];
            this.rfid_tag = _data["rfid_tag"];
            this.first_name = _data["first_name"];
            this.middle_name = _data["middle_name"];
            this.last_name = _data["last_name"];
            this.designation_id = _data["designation_id"];
            this.street_1 = _data["street_1"];
            this.street_2 = _data["street_2"];
            this.city_id = _data["city_id"];
            this.zip_code = _data["zip_code"];
            this.contact_number_1 = _data["contact_number_1"];
            this.contact_number_2 = _data["contact_number_2"];
            this.date_of_birth = _data["date_of_birth"];
            this.date_of_joining = _data["date_of_joining"];
            this.date_of_leaving = _data["date_of_leaving"];
            this.driving_experience = _data["driving_experience"];
            this.license_available = _data["license_available"];
            this.license_number = _data["license_number"];
            this.license_issue_date = _data["license_issue_date"];
            this.license_expiry_date = _data["license_expiry_date"];
            this.life_insurance_number = _data["life_insurance_number"];
            this.life_insurance_expiry_date = _data["life_insurance_expiry_date"];
            this.mediclaim_number = _data["mediclaim_number"];
            this.mediclaim_expiry_date = _data["mediclaim_expiry_date"];
            this.employee_photo = _data["employee_photo"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.status = _data["status"];
            this.creating_date = _data["creating_date"];
            this.updating_date = _data["updating_date"];
            this.city_name = _data["city_name"];
            this.state_id = _data["state_id"];
            this.state_name = _data["state_name"];
            this.country_id = _data["country_id"];
            this.country_name = _data["country_name"];
            this.branch = _data["branch"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            this.designation_name = _data["designation_name"];
            if (Array.isArray(_data["license_to_drive"])) {
                this.license_to_drive = [] as any;
                for (let item of _data["license_to_drive"])
                    this.license_to_drive!.push(LicenseToDriveOutputData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeDetailsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee_details_id"] = this.employee_details_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["employee_number"] = this.employee_number;
        data["rfid_tag"] = this.rfid_tag;
        data["first_name"] = this.first_name;
        data["middle_name"] = this.middle_name;
        data["last_name"] = this.last_name;
        data["designation_id"] = this.designation_id;
        data["street_1"] = this.street_1;
        data["street_2"] = this.street_2;
        data["city_id"] = this.city_id;
        data["zip_code"] = this.zip_code;
        data["contact_number_1"] = this.contact_number_1;
        data["contact_number_2"] = this.contact_number_2;
        data["date_of_birth"] = this.date_of_birth;
        data["date_of_joining"] = this.date_of_joining;
        data["date_of_leaving"] = this.date_of_leaving;
        data["driving_experience"] = this.driving_experience;
        data["license_available"] = this.license_available;
        data["license_number"] = this.license_number;
        data["license_issue_date"] = this.license_issue_date;
        data["license_expiry_date"] = this.license_expiry_date;
        data["life_insurance_number"] = this.life_insurance_number;
        data["life_insurance_expiry_date"] = this.life_insurance_expiry_date;
        data["mediclaim_number"] = this.mediclaim_number;
        data["mediclaim_expiry_date"] = this.mediclaim_expiry_date;
        data["employee_photo"] = this.employee_photo;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["status"] = this.status;
        data["creating_date"] = this.creating_date;
        data["updating_date"] = this.updating_date;
        data["city_name"] = this.city_name;
        data["state_id"] = this.state_id;
        data["state_name"] = this.state_name;
        data["country_id"] = this.country_id;
        data["country_name"] = this.country_name;
        data["branch"] = this.branch;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        data["designation_name"] = this.designation_name;
        if (Array.isArray(this.license_to_drive)) {
            data["license_to_drive"] = [];
            for (let item of this.license_to_drive)
                data["license_to_drive"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IEmployeeDetailsOutput {
    /** The auto-generated id of the employee details master */
    employee_details_id: number;
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The employee number with 13 character limit */
    employee_number: string;
    /** The employee rfid  tag with 50 character limit */
    rfid_tag: string;
    /** The employee first name with 50 character limit */
    first_name: string;
    /** The employee middle name with 50 character limit */
    middle_name: string;
    /** The employee last name with 50 character limit */
    last_name: string;
    /** The auto-generated id of the designation master */
    designation_id: number;
    /** The street_1 with 255 character limit */
    street_1: string;
    /** The street_1 with 255 character limit */
    street_2: string;
    /** The auto-generated id of the designation master */
    city_id: number;
    /** The zip code with 6 character limit */
    zip_code: string;
    /** The zip code with 13 character limit */
    contact_number_1: string;
    /** The zip code with 13 character limit */
    contact_number_2: string;
    /** The date of birth with 10 character limit */
    date_of_birth: string;
    /** The date of joining with 10 character limit */
    date_of_joining: string;
    /** The date 0f leaving with 10 character limit */
    date_of_leaving: string;
    /** The driving experience of employee */
    driving_experience: number;
    /** The  0 for NO 1 for Yes */
    license_available: number;
    /** The next passing date with 10 character limit */
    license_number: string;
    /** The license issue date with 10 character limit */
    license_issue_date: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date: string;
    /** The life insurance number with 50 character limit */
    life_insurance_number: string;
    /** The life insurance expiry date with 10 character limit */
    life_insurance_expiry_date: string;
    /** The mediclaim number with 50 character limit */
    mediclaim_number: string;
    /** The mediclaim expiry date with 10 character limit */
    mediclaim_expiry_date: string;
    /** The employee photo with 2048 character limit */
    employee_photo: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** Manage status of employee details. 0 For De-active, 1 For Active */
    status: number;
    /** The auto-generated creating time of tbl_alert_group item add */
    creating_date: any;
    /** The auto-generated creating or updating time of tbl_alert_group item add or update */
    updating_date: any;
    /** The city name with 255 character limit */
    city_name: string;
    /** The auto-generated id of the state master */
    state_id: number;
    /** The state name with 255 character limit */
    state_name: string;
    /** The auto-generated id of the country master */
    country_id: number;
    /** The country name with 255 character limit */
    country_name: string;
    /** The branch name with 255 character limit */
    branch: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 13 character limit */
    company_name: string;
    /** The designation name with 13 character limit */
    designation_name: string;
    license_to_drive: LicenseToDriveOutputData[];
}

